export * from './getScreenOrientation';
